import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isAgent: TComputedPropMapper<boolean> = ({ user }) => user.isAuthenticated && user.isAgent;
